export default "__VITE_ASSET__DiOcDG8i__"